import React, { useEffect, useRef, useState } from 'react'

import { Icons } from 'atoms'
import { Box, HStack, Pressable, Text } from 'native-base'
import { Animated, Easing, View } from 'react-native'

type AttachmentsAccordionProps = {
  children: React.ReactNode
}

export const AttachmentsAccordion: React.FunctionComponent<AttachmentsAccordionProps> = ({
  children
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const contentHeightRef = useRef(0)

  const heightAnim = useRef(new Animated.Value(0)).current

  const rotateAnim = useRef(new Animated.Value(0)).current

  const toggle = () => {
    const toOpen = !isOpen

    setIsOpen(toOpen)

    Animated.timing(heightAnim, {
      toValue: toOpen ? contentHeightRef.current : 0,
      duration: 400,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: false
    }).start()

    Animated.timing(rotateAnim, {
      toValue: toOpen ? 1 : 0,
      duration: 1000,
      easing: Easing.out(Easing.cubic),
      useNativeDriver: true
    }).start()
  }

  const rotate = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '180deg']
  })

  useEffect(() => {
    if (isOpen && contentHeightRef.current > 0) {
      heightAnim.setValue(contentHeightRef.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <Box bg="white" p={6} borderRadius="20px">
      <Pressable onPress={toggle} _pressed={{ opacity: 0.7 }}>
        <HStack alignItems="center" justifyContent="space-between">
          <HStack alignItems="center" space={2}>
            <Icons.Attachment color="gray.700" />
            <Text fontSize={16} fontWeight={400} color="gray.700">
              Material de apoio e anexos
            </Text>
          </HStack>
          <Animated.View style={{ transform: [{ rotate }] }}>
            <Icons.Chevron direction="down" color="gray.700" size="20px" />
          </Animated.View>
        </HStack>
      </Pressable>

      <Animated.View style={{ height: heightAnim, overflow: 'hidden' }}>
        <Box pt={4}>{children}</Box>
      </Animated.View>

      <View
        pointerEvents="none"
        style={{ position: 'absolute', opacity: 0, left: 0, right: 0 }}
        onLayout={(e) => {
          const h = e.nativeEvent.layout.height

          if (h && h !== contentHeightRef.current) {
            contentHeightRef.current = h

            if (isOpen) {
              heightAnim.setValue(h)
            }
          }
        }}>
        <Box pt={4}>{children}</Box>
      </View>
    </Box>
  )
}
